import axios from 'axios';
import React, {Component} from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {loginUser} from '../actions/authActions';
import {Button, FormGroup, FormControl, ControlLabel} from "react-bootstrap";
import "./Login.css"



const Badge = require("../assets/img/login-badge.svg");

function Modal(props){
    return (
        <div className={`modalContainer ${props.openModal ? "modalOpen" : "modalClose"}`}>
            <div className={"modalOverlay"} onClick={props.closeModal} />
            <div className={`modalLocation`}>
                <div className={"eventsBack"}>
                    {props.children}
                </div>
            </div>
        </div>
    )
}

class Login extends Component {
    constructor() {
        super();

        this.state = {
            username: "",
            password: "",
            errors: {},
            loginInvalid: true,

            openModal: false,
            signUpName: "",
            email: "",
            city: "",
            state: "",
        };
    }

    validateForm() {
        return this.state.username.length > 0 && this.state.password.length > 0;
    }

    validateInterestForm() {
        return this.state.signUpName.length > 0 && this.state.email.length > 0 && this.state.city.length > 0 && this.state.state.length > 0;
    }

    resetForm = () => {
        this.setState({
            signUpName: "",
            email: "",
            city: "",
            state: "",
            openModal: false,
        })
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }

    handleOpenModal = () => {
        this.setState({openModal: true})
    }

    handleCloseModal = () =>  {
        this.setState({openModal: false})
    }

    handleSubmit = event => {
        event.preventDefault();

        const user = {
            username: this.state.username,
            password: this.state.password,
        };
        this.props.loginUser(user);
    }

    handlePopupFormSubmit = event => {
        const params = {
            name: this.state.signUpName,
            email: this.state.email,
            city: this.state.city,
            state: this.state.state,
        }

        axios.post(`https://hooks.zapier.com/hooks/catch/2904692/bzdt71v/`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}})
            .then( res => {
                this.setState({openModal: false})
            });

        //axios.post(`${process.env.REACT_APP_API_URL_BASE}/api/installer/signup`, params )
        //    .then( res => {
        //        this.setState({openModal: false})
        //    });
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated) {
            this.props.history.push('/Dashboard');
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.auth.isAuthenticated) {
            this.props.history.push('/Dashboard');
        }
        if (nextProps.errors) {
            this.setState({errors: nextProps.errors});
        }
    }

    render() {
        return (
          <div>
            <div className={"flexibleLayout"}>
                <div className={"formBadgeContainer"}>
                    <div className={"formBadgeSecondContainer"}>
                        <div>
                            <div className="badgeLogo"><img className={"logoSize"} src={Badge} alt="badge"/></div>
                            <div className="login">
                                <div className="loginTitle">Sign In</div>
                                <div className="loginSubTitle">
                                    New to the Wrapify Installer Program? <span className={"clickHere"} onClick={this.handleOpenModal}>Click here</span> to get started.
                                </div>
                                <form onSubmit={this.handleSubmit}>
                                    <FormGroup controlId="username" bsSize="large">
                                        <ControlLabel className={"inputLabel"}>Email</ControlLabel>
                                        <FormControl
                                            autoFocus
                                            type="username"
                                            value={this.state.username}
                                            onChange={this.handleChange}
                                        />
                                    </FormGroup>
                                    <FormGroup controlId="password" bsSize="large">
                                        <ControlLabel className={"inputLabel"}>Password</ControlLabel>
                                        <FormControl
                                            value={this.state.password}
                                            onChange={this.handleChange}
                                            type="password"
                                        />
                                    </FormGroup>
                                    <Button
                                        className={"continueButton"}
                                        block
                                        bsSize="large"
                                        disabled={!this.validateForm()}
                                        type="submit"
                                    >
                                        Continue
                                    </Button>
                                </form>
                                {this.state.errors.errors != null && <div className="loginInvalid">Invalid Login</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="introContainer">
                        <div className="introInnerContainer">
                            <div className="col-xs-12">
                                <div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <h1 className="title-text white text-center">Become a certified Wrapify Installer</h1>
                                        </div>
                                        <div className="row">
                                            <div className="introSubTitle">
                                                <p className="white text-center">Watch the video below to learn how you can
                                                    start wrapping for Wrapify.</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-offset-1 col-xs-10 col-md-12 col-md-offset-0">
                                                    <div id="video-container">
                                                        <iframe width="100%" height="100%"
                                                                title="Become an installer at Wrapify"
                                                                src="https://www.youtube.com/embed/Tev8l8oOv2k?rel=0&amp;controls=0&amp;showinfo=0&amp;wmode=opaque"
                                                                frameBorder="0" allowFullScreen=""></iframe>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </div>
                </div>
            </div>

            <Modal openModal={this.state.openModal} closeModal={this.handlePopupFormSubmit}>
                <div className={"signUpTitle"}>Sign Up</div>
                <div className="signUpSubTitle">Fill out the form and we will contact you right away!</div>
                    <FormGroup controlId="signUpName" bsSize="medium">
                        <FormControl
                            placeholder="Shop Name*"
                            autoFocus
                            type="name"
                            value={this.state.signUpName}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                    <FormGroup controlId="email" bsSize="large">
                        <FormControl
                            placeholder="Email*"
                            autoFocus
                            type="email"
                            value={this.state.email}
                            onChange={this.handleChange}
                        />
                    </FormGroup>
                <FormGroup controlId="city" bsSize="large">
                    <FormControl
                        placeholder="City*"
                        autoFocus
                        type="city"
                        value={this.state.city}
                        onChange={this.handleChange}
                    />
                </FormGroup>
                <FormGroup controlId="state" bsSize="large">
                        <FormControl
                            placeholder="State*"
                            autoFocus
                            type="state"
                            value={this.state.state}
                            onChange={this.handleChange}
                        />
                </FormGroup>
                    <button
                        className={"interestButton"}
                        disabled={!this.validateInterestForm()}
                        onClick={this.handlePopupFormSubmit}
                    >
                        Submit
                    </button>
            </Modal>
        
          </div>
        );
    }
}

Login.propTypes = {
    loginUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
     mapStateToProps,
     {loginUser}
)(Login);


// WEBPACK FOOTER //
// ./src/layouts/Login.js